import { ACCESS } from '@src/configs/permission'
import lazyLoading from '@src/components/widgets/LazyLoading'

import { TRouteConfig } from '../routeConfig'

const List = lazyLoading(() => import('@src/pages/product-property/product-type'))
const Create = lazyLoading(() => import('@src/pages/product-property/product-type/create'))
const Detail = lazyLoading(() => import('@src/pages/product-property/product-type/detail'))

const productTypeRouter: TRouteConfig[] = [
  {
    path: '/product-type',
    Element: List,
    key: ACCESS.LIST_PRODUCT_TYPE,
  },
  {
    path: '/create-product-type',
    Element: Create,
    key: ACCESS.ADD_PRODUCT_TYPE,
  },
  {
    path: '/product-type/:id',
    Element: Detail,
    key: ACCESS.VIEW_PRODUCT_TYPE,
  },
]

export { productTypeRouter }
